import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { API_URL } from "../../../../config";

const MedicalIntakeForm = ({selectedFormId,data,selectedClientDetails}) => {
  const { t } = useTranslation();
  const initialFormData = {
    name: selectedClientDetails ? `${selectedClientDetails.firstname} ${selectedClientDetails.lastname}` : "",
    sex: "",
    age: "",
    email: "",
    tel: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    breathingQuestions: Array(18).fill(""),
    otherComments: "",
  }
  const [formData, setFormData] = useState(data?data:initialFormData);

  // Input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Textarea change handler for questions
  const handleQuestionChange = (index, value) => {
    const updatedQuestions = [...formData.breathingQuestions];
    updatedQuestions[index] = value;
    setFormData((prev) => ({
      ...prev,
      breathingQuestions: updatedQuestions,
    }));
  };

  // Submit handler

    const [successModal, setsuccessModal] = useState(false);
    const successToggleModal = () => setsuccessModal(!successModal);
  const [loading, setLoading] = useState(false);


const handleSubmit = () => {
  const userId = localStorage.getItem("user_id");
  const selectedClient = localStorage.getItem("selectedClient");
  const accessToken = localStorage.getItem("accessToken");

  const client_id = selectedClient === "null" ? userId : selectedClient;

  // Start loader
  setLoading(true);



  // Prepare payload (no need to stringify form_data here)
  const payload = {
    client_id: client_id,
    form_id: selectedFormId, // Ensure this variable is defined
    form_data: JSON.stringify(formData),
  };

  console.log("📤 Sending form payload:", payload);

  fetch(API_URL + "/forms/client/form-submit", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-access-token": accessToken,
    },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((resp) => {
      console.log("✅ Response:", resp);
      if (resp.status) {
        successToggleModal();
        setFormData(initialFormData);
      } else {
        console.error("❌ Upload failed:", resp.message);
        console.log("Upload failed: " + resp.message);
      }
    })
    .catch((err) => {
      console.error("⚠️ Error submitting form:", err);
      console.log("Something went wrong while submitting the form.");
    })
    .finally(() => {
      // Stop loader in all cases
      setLoading(false);
    });
};
  // Base input style
  const baseInputStyle = {
    backgroundColor: "#f1f4ff",
    padding: "4px",
    borderBottom: "2px solid #444",
    borderTop: "none",
    borderLeft: "none",
    borderRight: "none",
    outline: "none",
  };

  // Function to remove outline inline
  const removeOutline = {
    outline: "none",
    boxShadow: "none",
  };

  const getInputStyle = (width) => ({ ...baseInputStyle, width, ...removeOutline });

  const formStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: 16,
    backgroundColor: "white",
    border: !data && "1px solid #ccc",
    fontFamily: "Arial, sans-serif",
    marginTop: 16,
  };

  const headingStyle = {
    fontSize: "22px",
    fontWeight: "bold",
    color: "#800080",
    textAlign: "center",
    marginBottom: "16px",
  };

  const fieldRowStyle = {
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "16px",
    gap: "8px",
  };

  const fieldGroupStyle = {
    display: "flex",
    alignItems: "flex-end",
    gap: "8px",
  };

  const questionBoxStyle = {
    border: "1px solid #888",
    padding: "8px",
    marginBottom: "8px",
    backgroundColor: "#f1f4ff",
  };

  const questions = [
    "Tell us about your breathing. Is breathing ever a challenge, or an issue, for you?",
    "Medical conditions, e.g., cardiovascular, diabetes?",
    "Respiratory disorders, e.g., asthma, COPD?",
    "Injuries, past and present, e.g., chest, back, neck?",
    "Physical complaints, e.g., headache, hypertension, stress symptoms?",
    "Emotional challenges, e.g., panic, anxiety, anger?",
    "Pregnancy experiences, current or previous?",
    "Current prescriptions, e.g., depression, anxiety, hypertension?",
    "Life traumas, e.g., emotional abuse, PTSD, chronic stress?",
    "Pain issues, past or present, acute or chronic?",
    "Physical limitations, e.g., fatigue, speech, movement?",
    "Allergies and sensitivities, e.g., food, environment?",
    "Deficiencies, e.g., electrolytes (kidney dysfunction)?",
    'Relationship difficulties, or social challenges, e.g., significant other, "children," employment?',
    "Work related challenges, e.g., environment, unreasonable demands, co-workers, superiors?",
    "Learning issues, e.g., attention deficit, memory, focus?",
    "Performance issues, e.g., public speaking, testing, performing arts, operating technology?",
    "Are you seeing a healthcare practitioner? If so, what kind of practitioner(s), e.g. physician?",
  ];

  return (
    <div style={formStyle}>
      <h1 style={headingStyle}>TELL US MORE ABOUT YOURSELF.</h1>

      <div style={fieldRowStyle}>
        <div style={fieldGroupStyle}>
          <span>Name:</span>
          <input
            name="name"
            type="text"
            value={formData.name}
            disabled={Boolean(selectedClientDetails)}
            onChange={handleInputChange}
            style={getInputStyle(300)}
            onFocus={(e) => (e.target.style.outline = "none")}
          />
        </div>

        <div style={fieldGroupStyle}>
          <span>Sex</span>
          <input
            name="sex"
            type="text"
            value={formData.sex}
            onChange={handleInputChange}
            style={getInputStyle(55)}
            onFocus={(e) => (e.target.style.outline = "none")}
          />
        </div>

        <div style={fieldGroupStyle}>
          <span>Age</span>
          <input
            name="age"
            type="text"
            value={formData.age}
            onChange={handleInputChange}
            style={getInputStyle(55)}
            onFocus={(e) => (e.target.style.outline = "none")}
          />
        </div>

        <div style={fieldGroupStyle}>
          <span>Email:</span>
          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleInputChange}
            style={getInputStyle(140)}
            onFocus={(e) => (e.target.style.outline = "none")}
          />
        </div>

        <div style={fieldGroupStyle}>
          <span>Tel:</span>
          <input
            name="tel"
            type="tel"
            value={formData.tel}
            onChange={handleInputChange}
            style={getInputStyle(140)}
            onFocus={(e) => (e.target.style.outline = "none")}
          />
        </div>
      </div>

      <div style={fieldRowStyle}>
        <div style={fieldGroupStyle}>
          <span>Address:</span>
          <input
            name="address"
            type="text"
            value={formData.address}
            onChange={handleInputChange}
            style={getInputStyle(320)}
            onFocus={(e) => (e.target.style.outline = "none")}
          />
        </div>

        <div style={fieldGroupStyle}>
          <span>City</span>
          <input
            name="city"
            type="text"
            value={formData.city}
            onChange={handleInputChange}
            style={getInputStyle(190)}
            onFocus={(e) => (e.target.style.outline = "none")}
          />
        </div>

        <div style={fieldGroupStyle}>
          <span>State</span>
          <input
            name="state"
            type="text"
            value={formData.state}
            onChange={handleInputChange}
            style={getInputStyle(55)}
            onFocus={(e) => (e.target.style.outline = "none")}
          />
        </div>

        <div style={fieldGroupStyle}>
          <span>Zip</span>
          <input
            name="zip"
            type="text"
            value={formData.zip}
            onChange={handleInputChange}
            style={getInputStyle(120)}
            onFocus={(e) => (e.target.style.outline = "none")}
          />
        </div>
      </div>

      {questions.map((question, index) => (
        <div key={index} style={questionBoxStyle}>
          <label>{question}</label>
          <textarea
            name={`question-${index}`}
            value={formData.breathingQuestions[index]}
            onChange={(e) => handleQuestionChange(index, e.target.value)}
            style={{ width: "100%", border: "none", backgroundColor: "transparent", outline: "none" }}
            onFocus={(e) => (e.target.style.outline = "none")}
          />
        </div>
      ))}

      <div style={questionBoxStyle}>
        <label>Other Comments:</label>
        <textarea
          name="otherComments"
          value={formData.otherComments}
          onChange={handleInputChange}
          style={{ width: "100%", border: "none", backgroundColor: "transparent", outline: "none" }}
          onFocus={(e) => (e.target.style.outline = "none")}
        />
      </div>

     {!data && <div className="client-submit-btn">
        <button type="button" onClick={handleSubmit}>
          {loading?t("Submitting..."):t("Submit")}
        </button>
      </div>}
         <Modal
                          isOpen={successModal}
                          toggle={successToggleModal}
                          className="connect-box"
                          centered={true}
                        >
                          <ModalHeader toggle={successToggleModal}>
                            <span className="ml-1 roititle font-weight-bold">
                              Successfull
                            </span>
                          </ModalHeader>
                          <ModalBody>
                            <div className="modal-p">
                              <p>Client form has been submitted successfully.</p>
                            </div>
                          </ModalBody>
                        </Modal>
    </div>
  );
};

export default MedicalIntakeForm;
